const t = {
  name: "SoftwareFilled",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M2 7C2 4.23772 4.23772 2 7 2H11V12.5858L8 9.58582L6.58578 11L12 16.4142L17.4142 11L16 9.58582L13 12.5858V2H17C19.7623 2 22 4.23772 22 7V17C22 19.7623 19.7623 22 17 22H7C4.23772 22 2 19.7623 2 17V7Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as SoftwareFilled
};
